<template>
  <div class="breadcrumbs text-small2">
    <div class="breadcrumbs__content row-2">
      <div class="breadcrumbs__content__items">
        <div v-for="(breadcrumb, index) in breadcrumbs" :key="index">
          <template v-if="index < breadcrumbs.length - 1">
            <NuxtLink
              class="simple-underline-hover"
              :to="localePath(breadcrumb.path)"
            >
              <span>{{ breadcrumb.name }}</span>
            </NuxtLink>
            <span> >&nbsp;</span>
          </template>
          <template v-else>
            <span>{{ breadcrumb.name }}</span>
          </template>
        </div>
      </div>
      <div class="title-medium2 page-title" v-html="pageTitle" />
    </div>
  </div>
</template>

<script setup>
import { useVinoItem } from '~/composables/vino-data.js'
import { useBirraItem } from '~/composables/birra-data.js'

const props = defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
  subcategories: {
    type: Object,
    default: () => ({}),
  },
  pageHandle: {
    type: String,
    default: '',
  },
  pageTitle: {
    type: String,
    default: '',
  },
})

const { findVinoItemBySlug } = useVinoItem(
  props.categories,
  props.subcategories,
)

const { findBirraItemBySlug } = useBirraItem(
  props.categories,
  props.subcategories,
)

const route = useRoute()
const { locale } = useI18n()

// Computed per generare la lista di breadcrumbs
// Osserva l'URL e genera un array di breadcrumbs
const breadcrumbs = computed(() => {
  // Divide l'URL in segmenti e filtra quelli vuoti
  const pathArray = route.path
    .split('/')
    .filter((segment) => segment && segment !== locale.value)

  // Se c'è più di un segmento, genera un breadcrumb per ciascuno
  return pathArray.length > 1
    ? pathArray.map((segment, index) => {
        // Trova la categoria corrispondente al segmento usando la funzione appropriata
        const category =
          props.pageHandle === 'vinoPage'
            ? findVinoItemBySlug(segment)
            : findBirraItemBySlug(segment)

        // Se la categoria esiste, usa il suo titolo come nome, altrimenti usa il segmento stesso
        let name = category ? category.title : segment

        // Capitalizza ogni parola nel nome
        name = name
          .split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')

        // Restituisce l'oggetto breadcrumb con nome e percorso
        const pathPrefix = locale.value === 'it' ? '' : `/${locale.value}`
        return {
          name,
          path: `${pathPrefix}/` + pathArray.slice(0, index + 1).join('/'),
        }
      })
    : []
})
</script>

<script>
export default {
  name: 'ListingBreadcrumbs',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
